// USER LIST
export const CURRENCY_MANAGER_LIST = "CURRENCY_MANAGER_LIST";
export const CURRENCY_MANAGER_LIST_SUCCESS = "CURRENCY_MANAGER_LIST_SUCCESS";
export const CURRENCY_MANAGER_LIST_FAIL = "CURRENCY_MANAGER_LIST_FAIL";
export const CURRENCY_MANAGER_LIST_RESET = "CURRENCY_MANAGER_LIST_RESET";
export const CURRENCY_MANAGER_LIST_COLUMN = "CURRENCY_MANAGER_LIST_COLUMN";

// USER ROLE LIST
export const CURRENCY_MANAGER_ROLE_LIST = "CURRENCY_MANAGER_ROLE_LIST";
export const CURRENCY_MANAGER_ROLE_LIST_SUCCESS = "CURRENCY_MANAGER_ROLE_LIST_SUCCESS";
export const CURRENCY_MANAGER_ROLE_LIST_FAIL = "CURRENCY_MANAGER_ROLE_LIST_FAIL";
export const CURRENCY_MANAGER_ROLE_LIST_RESET = "CURRENCY_MANAGER_ROLE_LIST_RESET";
export const CURRENCY_MANAGER_ROLE_LIST_COLUMN = "CURRENCY_MANAGER_ROLE_LIST_COLUMN";

// USER CREATE
export const CURRENCY_MANAGER_CREATE = "CURRENCY_MANAGER_CREATE";
export const CURRENCY_MANAGER_CREATE_SUCCESS = "CURRENCY_MANAGER_CREATE_SUCCESS";
export const CURRENCY_MANAGER_CREATE_FAIL = "CURRENCY_MANAGER_CREATE_FAIL";
export const CURRENCY_MANAGER_CREATE_RESET = "CURRENCY_MANAGER_CREATE_RESET";

// USER DETAIL
export const CURRENCY_MANAGER_DETAIL = "CURRENCY_MANAGER_DETAIL";
export const CURRENCY_MANAGER_DETAIL_SUCCESS = "CURRENCY_MANAGER_DETAIL_SUCCESS";
export const CURRENCY_MANAGER_DETAIL_FAIL = "CURRENCY_MANAGER_DETAIL_FAIL";
export const CURRENCY_MANAGER_DETAIL_RESET = "CURRENCY_MANAGER_DETAIL_RESET";

// USER UPDATE
export const CURRENCY_MANAGER_UPDATE = "CURRENCY_MANAGER_UPDATE";
export const CURRENCY_MANAGER_UPDATE_SUCCESS = "CURRENCY_MANAGER_UPDATE_SUCCESS";
export const CURRENCY_MANAGER_UPDATE_FAIL = "CURRENCY_MANAGER_UPDATE_FAIL";
export const CURRENCY_MANAGER_UPDATE_RESET = "CURRENCY_MANAGER_UPDATE_RESET";

// USER DELETE
export const CURRENCY_MANAGER_DELETE = "CURRENCY_MANAGER_DELETE";
export const CURRENCY_MANAGER_DELETE_SUCCESS = "CURRENCY_MANAGER_DELETE_SUCCESS";
export const CURRENCY_MANAGER_DELETE_FAIL = "CURRENCY_MANAGER_DELETE_FAIL";
export const CURRENCY_MANAGER_DELETE_RESET = "CURRENCY_MANAGER_DELETE_RESET";

// USER ACTIVE
export const CURRENCY_MANAGER_ACTIVE = "CURRENCY_MANAGER_ACTIVE";
export const CURRENCY_MANAGER_ACTIVE_SUCCESS = "CURRENCY_MANAGER_ACTIVE_SUCCESS";
export const CURRENCY_MANAGER_ACTIVE_FAIL = "CURRENCY_MANAGER_ACTIVE_FAIL";
export const CURRENCY_MANAGER_ACTIVE_RESET = "CURRENCY_MANAGER_ACTIVE_RESET";
